(() => {
  function init(root) {
    if (root.dataset.owReady) return;
    root.dataset.owReady = 'true';
    const gallery = root.querySelector('[data-bm-product-gallery]');
    const thumbs = [...root.querySelectorAll('[data-ow-slide]')];
    if (!gallery) return;
    const slides = [...gallery.children];
    const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    thumbs.forEach(button => button.addEventListener('click', () => {
      const slide = slides[Number(button.dataset.owSlide)];
      if (slide) gallery.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: motion});
    }));
    gallery.addEventListener('scroll', () => {
      const left = gallery.getBoundingClientRect().left;
      let nearest = 0;
      slides.forEach((slide, index) => { if (Math.abs(slide.getBoundingClientRect().left-left) < Math.abs(slides[nearest].getBoundingClientRect().left-left)) nearest = index; });
      thumbs.forEach((button,index) => button.setAttribute('aria-pressed', String(index === nearest)));
    }, {passive:true});
  }
  document.querySelectorAll('.bm-product--outerwear').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.bm-product--outerwear').forEach(init));
})();
